import { createAction } from '@reduxjs/toolkit';
import { Tag } from '../../../general/model';
import { SearchParams, SearchINode } from './model';

export const searchTextChanged = createAction<
  { text: string },
  'creativeHub/search/SEARCH_TEXT_CHANGED'
>('creativeHub/search/SEARCH_TEXT_CHANGED');
export const loadSearchStarted = createAction<void, 'creativeHub/search/LOAD_SEARCH_STARTED'>(
  'creativeHub/search/LOAD_SEARCH_STARTED',
);
export const loadSearchSuccess = createAction<
  { nodes: SearchINode[] },
  'creativeHub/search/LOAD_SEARCH_SUCCESS'
>('creativeHub/search/LOAD_SEARCH_SUCCESS');
export const loadSearchError = createAction<{ error: any }, 'creativeHub/search/LOAD_SEARCH_ERROR'>(
  'creativeHub/search/LOAD_SEARCH_ERROR',
);
export const loadSearchRequested = createAction<
  SearchParams,
  'creativeHub/search/LOAD_SEARCH_REQUESTED'
>('creativeHub/search/LOAD_SEARCH_REQUESTED');
export const tagsUpdated = createAction<{ tags: Tag[] }, 'creativeHub/search/tagsUpdated'>(
  'creativeHub/search/tagsUpdated',
);
